// src/components/TyperOnScroll.jsx
import TypeWriterEffect from "react-typewriter-effect";
import { useInView } from "react-intersection-observer";

export default function TyperOnScroll({
  text,
  multiText,
  typeSpeed = 55,
  startDelay = 120,
  threshold = 0.35,
  className = "",
}) {
  const { ref, inView } = useInView({ triggerOnce: true, threshold }); // starts when X% visible [web:124]
  return (
    <div ref={ref} className={className}>
      {inView && (
        <TypeWriterEffect
          text={text}
          multiText={multiText}
          typeSpeed={typeSpeed}
          startDelay={startDelay}
          cursorColor="currentColor"
        />
      )}
    </div>
  );
}
